<template>
  <div v-if="unique && unique.length" :key="documentKey" class="box px-2">
    <div class="header align-center layout">
      <div>{{ title }}</div>
      <v-spacer />
      <v-btn small icon @click.stop="open = !open">
        <v-icon>{{ open ? icons.arrows.top : icons.arrows.down }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="open" class="content">
        <v-chip-group column>
          <v-chip
            v-for="assignment in unique"
            :key="assignment._id"
            link
            :to="{ path: documentKey, query: { presentation: assignment._id } }"
          >
            {{ assignment.name }}
          </v-chip>
        </v-chip-group>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import icons from '../../mixins/icons';
import { uniqBy } from 'lodash';
export default {
  name: 'AssignmentCard',
  mixins: [icons],
  props: {
    title: String,
    assignments: Array,
    documentKey: String
  },

  data() {
    return {
      open: true
    };
  },
  computed: {
    unique() {
      return uniqBy(this.assignments, e => e._id);
    }
  }
};
</script>

<style scoped>
.box {
  padding-top: 20px;
  padding-bottom: 20px;
}
.header {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
</style>
